import { render, staticRenderFns } from "./StateType.vue?vue&type=template&id=23ae9350&scoped=true&"
import script from "./StateType.vue?vue&type=script&lang=js&"
export * from "./StateType.vue?vue&type=script&lang=js&"
import style0 from "./StateType.vue?vue&type=style&index=0&id=23ae9350&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ae9350",
  null
  
)

export default component.exports